<template>
  <div>
    <!-- <section>
      <div class="container-fluid sectionFix bannersCont">
        <div class="row bannersCont">
          <router-link
            to="/products?category=STICKERS#!"
            class="col-lg-6 dark-overlay split-screen-column align-items-start"
            style="
              background-image: url(../assets/banner1low.png);
              background-color: #d2cecb;
              text-decoration: none;
            "
          >
            <div class="mt-7 overlay-content px-lg-5 bannerTitle">
              <h1 class="text-white display-4 fw-bold split-screen-heading">
                STICKERS
              </h1>
            </div>
          </router-link>
          <router-link
            to="/products?category=POSTERS#!"
            class="col-lg-6 dark-overlay split-screen-column align-items-start"
            style="
              background-image: url(../assets/banner2low.png);
              background-color: #e5b6b4;
              text-decoration: none;
            "
          >
 <div class="col-lg-6 split-screen-column align-items-center align-items-lg-end" style="background-image: url(../assets/backk2.jpg); background-color: #e5b6b4;">  
            <div class="overlay-content px-lg-5 mb-lg-5 bannerTitle">
              <h1
                class="display-4 fw-bold split-screen-heading"
                style="color: white"
              >
                POSTERS
              </h1>
            </div>
          </router-link>
        </div>
      </div>
    </section> -->

    <!-- <section class="sectionFix">
      <div
        class="owl-carousel owl-theme owl-dots-modern home-slider owl-loaded owl-drag"
      >
        <div class="owl-stage-outer">
          <div
            class="owl-stage"
            style="
              transform: translate3d(-3112px, 0px, 0px);
              transition: all;
              width: 10892px;
            "
          >
            <div class="owl-item active" style="width: 1556px">
              <div
                class="item d-flex align-items-center bg-dark dark-overlay"
                style="height: 800px"
              >
                <img
                  class="bg-image"
                  src="../assets/banner1test.webp"
                  alt=""
                />
                <div class="container py-6">
                  <div class="row">
                    <div
                      class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
                    >
                      <h1 class="mb-4 text-2xl display-2 text-uppercase fw-bold">
                        Davinci 
                      </h1>
                      <p class="mb-5 text-base lead">
                        Davinci con su arte en el mundo
                        de la vaporización ha hecho que
                        sus vaporizadores sean de alta
                        resistencia y efectividad.
                      </p>
                      <p>
                        <router-link class="btnSlider" to="/products?category=Vaporizadores&subcategory=Davinci"
                          >Comprar Davinci</router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="owl-item cloned" style="width: 1556px">
              <div
                class="item d-flex align-items-center"
                style="height: 800px"
              >
                <img
                  class="bg-image"
                  src="https://d19m59y37dris4.cloudfront.net/sell/2-0/img/photo/haley-phelps-62815-unsplash.jpg"
                  alt=""
                />
                <div class="container py-6">
                  <div class="row">
                    <div
                      class="mx-auto text-center text-white col-lg-8 col-xl-6 position-relative"
                    >
                      <h5 class="mb-4 text-uppercase fw-light letter-spacing-5">
                        Our bestseller
                      </h5>
                      <h1 class="mb-5 display-1 fw-bold text-serif">
                        Skinny Jeans
                      </h1>
                      <p>
                        <a class="btn btn-light" href="category.html"
                          >View collection</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="owl-item " style="width: 1556px">
              <div
                class="item d-flex align-items-center"
                style="background: rgb(248, 213, 207); height: 800px"
              >
                <img
                  class="bg-image"
                  src="https://d19m59y37dris4.cloudfront.net/sell/2-0/img/photo/matheus-ferrero-334418-unsplash.jpg"
                  alt=""
                />
                <div class="container py-6">
                  <div class="row">
                    <div
                      class="mx-auto text-center text-white col-lg-8 col-xl-6 position-relative"
                    >
                      <h5
                        class="mb-4 text-white text-uppercase fw-light letter-spacing-5"
                      >
                        Just arrived
                      </h5>
                      <h1 class="mb-5 display-2 fw-bold text-serif">
                        Denim Jackets
                      </h1>
                      <p class="mb-4 lead">
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua.
                      </p>
                      <p>
                        <a class="btn btn-light" href="category.html"
                          >View collection</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="owl-item" style="width: 1556px">
              <div
                class="item d-flex align-items-center bg-dark dark-overlay"
                style="height: 800px"
              >
                <img
                  class="bg-image"
                  src="https://d19m59y37dris4.cloudfront.net/sell/2-0/img/photo/ian-dooley-347942-unsplash.jpg"
                  alt=""
                />
                <div class="container py-6">
                  <div class="row">
                    <div
                      class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
                    >
                      <h1 class="mb-4 display-2 text-uppercase fw-bold">
                        Skeleton Tees
                      </h1>
                      <p class="mb-5 lead">
                        Lorem ipsum dolor sit amet, consectetur adipisicing
                        elit, sed do eiusmod tempor incididunt ut labore et
                        dolore magna aliqua.
                      </p>
                      <p>
                        <a class="btn btn-light" href="category.html"
                          >Start shopping</a
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
        <div class="owl-nav">
          <button type="button" role="presentation" class="owl-prev">
            <img src="img/prev.svg" alt="" width="50" /></button
          ><button type="button" role="presentation" class="owl-next">
            <img src="img/next.svg" alt="" width="50" />
          </button>
        </div>
        <div class="owl-dots disabled"></div>
        <div class="owl-thumbs"></div>
      </div>
    </section> -->

    <section class="sectionFix">
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="4000"
        controls
        indicators
        fade
        background="#00000"
        img-width="1024"
        img-height="780"
        no-hover-pause
        class="desktopCarousel"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide>
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              src="../assets/bannerSomaWeb.jpg"
              alt="image slot"
            />
          </template>
        </b-carousel-slide>

        <!-- Text slides with image -->
        <b-carousel-slide img-src="../assets/banner1test.webp">
          <div class="container w-full h-full py-6">
            <div class="row">
              <div
                class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
              >
                <h1
                  class="mb-4 display-2 text-uppercase fw-bold"
                  style="font-size: 50px"
                >
                  Davinci
                </h1>
                <p class="mb-5 text-base lead">
                  Davinci con su arte en el mundo de la vaporización ha hecho
                  que sus vaporizadores sean de alta resistencia y efectividad.
                </p>
                <p>
                  <router-link
                    class="btnSlider"
                    to="/products?category=Vaporizadores&subcategory=Davinci"
                    >Comprar Davinci</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </b-carousel-slide>

        <!-- Slides with img slot -->
        <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
        <b-carousel-slide>
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              src="../assets/banner2test.webp"
              alt="image slot"
            />
          </template>
          <div class="container w-full h-full py-6">
            <div class="row">
              <div
                class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
              >
                <h1
                  class="mb-4 display-2 text-uppercase fw-bold"
                  style="font-size: 50px"
                >
                  G-Pen
                </h1>
                <p class="mb-5 text-base lead">
                  La familia G-Pen tiene sistemas que ayudan a que tu
                  experiencia sea perfecta.
                </p>
                <p>
                  <router-link
                    class="btnSlider"
                    to="/products?category=Vaporizadores&subcategory=Davinci"
                    >Comprar G-Pen</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </b-carousel-slide>
      </b-carousel>

      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="5000"
        controls
        indicators
        fade
        background="#00000"
        img-width="1024"
        img-height="780"
        no-hover-pause
        class="mobileCarousel"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide>
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              src="../assets/bannerSomaMobile.jpg"
              alt="image slot"
            />
          </template>
        </b-carousel-slide>

        <!-- Text slides with image -->
        <b-carousel-slide img-src="../assets/banner1testmobile.webp">
          <div class="container w-full h-full py-6">
            <div class="row">
              <div
                class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
              >
                <h1
                  class="mb-4 display-2 text-uppercase fw-bold"
                  style="font-size: 50px"
                >
                  Davinci
                </h1>
                <p class="mb-5 text-base lead">
                  Davinci con su arte en el mundo de la vaporización ha hecho
                  que sus vaporizadores sean de alta resistencia y efectividad.
                </p>
                <p>
                  <router-link
                    class="btnSlider"
                    to="/products?category=Vaporizadores&subcategory=Davinci"
                    >Comprar Davinci</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </b-carousel-slide>

        <!-- Slides with img slot -->
        <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->

        <b-carousel-slide>
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="480"
              src="../assets/banner2testmobile.webp"
              alt="image slot"
            />
          </template>
          <div class="container w-full h-full py-6">
            <div class="row">
              <div
                class="mx-auto text-center text-white col-lg-8 col-xl-6 overlay-content"
              >
                <h1
                  class="mb-4 display-2 text-uppercase fw-bold"
                  style="font-size: 50px"
                >
                  G-Pen
                </h1>
                <p class="mb-5 text-base lead">
                  La familia G-Pen tiene sistemas que ayudan a que tu
                  experiencia sea perfecta.
                </p>
                <p>
                  <router-link
                    class="btnSlider"
                    to="/products?category=Vaporizadores&subcategory=Davinci"
                    >Comprar G-Pen</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </b-carousel-slide>
      </b-carousel>
    </section>

    <div style="margin-top: 80px" class="sectionTitle">
      <span>Últimos ingresos</span>
      <p class="text-gray-500">
        Descubrí las novedades que acaban de llegar a la tienda.
      </p>
    </div>

    <section class="pb-2" style="margin: 70px 0">
      <div class="container">
        <!-- <div class="row">
          <div class="mx-auto text-center col-xl-8">
            <h2 class="text-uppercase">NUEVOS PRODUCTOS</h2>
            <p class="lead text-muted">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          </div>
        </div> -->

        <div class="row">
          <!-- product-->
          <div class="row">
            <!-- product-->
            <div
              class="col-lg-3 col-md-4 col-6"
              v-for="item in mostWantedProducts"
            >
              <router-link :to="/product/ + item.slug">
                <div class="">
                  <div class="product-image" style="border: none !important">
                    <div class="ribbon ribbon-info" v-if="item.discount">
                      En oferta
                    </div>
                    <img
                      class="img-fluid productBorderRadius"
                      :src="item.image"
                      alt="product"
                    />
                    <div
                      class="product-hover-overlay"
                      style="border-radius: 4px"
                    >
                      <div
                        class="product-hover-overlay-buttons"
                        style="border-radius: 4px"
                      >
                        <a
                          class="btn btn-dark btn-buy"
                          style="background-color: #1c4c3b; border-radius: 4px"
                          href=""
                          ><span
                            class="btn-buy-label"
                            style="font-size: 11px; letter-spacing: 1px"
                            >Ver más</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="py-2">
                    <p class="mb-1 text-sm text-muted">{{ item.category }}</p>
                    <h3 class="mb-1 h6" style="text-transform: uppercase">
                      <a class="text-dark" href="detail.html">{{
                        item.name
                      }}</a>
                    </h3>
                    <span v-if="USDEnabled == true" class="text-muted"
                      >AR{{ priceConverter(item.price) }}
                    </span>
                    <span v-if="USDEnabled == false" class="text-muted"
                      >AR{{ priceConverter(item.price * USDData.value) }}
                    </span>
                  </div>
                </div>
              </router-link>
            </div>
            <!-- /product-->
          </div>
          <!-- /product-->
        </div>
      </div>
    </section>

    <div class="sectionTitle">
      <span>Vaporizadores</span>
      <p class="text-gray-500">
        Disfrutá de una experiencia única de vapeo con nuestra amplia variedad
        de productos.
      </p>
    </div>

    <div class="categoriesBanner">
      <router-link to="/products?filter=herbal" style="text-decoration: none">
        <div class="categoriesBannerItem">
          <img src="../assets/HERBALES.png" alt="" />
          <span>Herbales</span>
        </div>
      </router-link>
      <router-link to="/products?filter=pen" style="text-decoration: none">
        <div class="categoriesBannerItem">
          <img src="../assets/PEN.png" alt="" />
          <span>Pen</span>
        </div>
      </router-link>
      <router-link to="/products?filter=e-nail" style="text-decoration: none">
        <div class="categoriesBannerItem">
          <img src="../assets/ENAILS.png" alt="" />
          <span>E-Nails</span>
        </div>
      </router-link>

      <router-link
        to="/products?filter=escritorio"
        style="text-decoration: none"
      >
        <div class="categoriesBannerItem">
          <img src="../assets/ESCRITORIO.png" alt="" />
          <span>Escritorio</span>
        </div>
      </router-link>
    </div>

    <div class="sectionTitle">
      <span>Productos mas vendidos</span>
      <p class="text-gray-500">
        Estos son los productos que prefieren nuestros clientes.
      </p>
    </div>

    <section class="py-4" style="margin: 50px 0">
      <div class="container">
        <!-- <div class="row">
          <div class="mx-auto mb-5 text-center col-xl-8">
            <h2>LO MAS VENDIDO</h2>
            <p class="lead text-muted">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="mb-4 col-md-6 d-flex align-items-md-stretch mb-md-0">
            <div
              class="py-6 text-center text-white d-flex align-items-center dark-overlay w-100 py-md-0 model1img"
              style=""
            >
              <a class="tile-link" href="category.html"> </a>
              <div class="card-img-overlay w-100 overlay-content">
                <h2 class="mb-0 display-2 fw-bold text-uppercase">UPTEMPO</h2>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4 text-center text-white border-0 card dark-overlay">
              <img
                class="card-img"
                src="../assets/model3.jpeg"
                alt="Ladies"
              /><a class="tile-link" href="category.html"> </a>
              <div class="card-img-overlay d-flex align-items-center">
                <div class="text-center w-100 overlay-content">
                  <h2 class="mb-0 text-center display-4 fw-bold text-uppercase">
                    RETRO 4
                  </h2>
                </div>
              </div>
            </div>
            <div class="text-center text-white border-0 card dark-overlay">
              <img
                class="card-img"
                src="../assets/model2.jpg"
                alt="Accessories"
              /><a class="tile-link" href="category.html"> </a>
              <div class="card-img-overlay d-flex align-items-center">
                <div class="text-center w-100 overlay-content">
                  <h2 class="mb-0 text-center display-4 fw-bold text-uppercase">
                    AIR MAX
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <!-- product-->
          <div
            class="col-lg-3 col-md-4 col-6"
            v-for="item in mostWantedProducts"
          >
            <router-link :to="/product/ + item.slug">
              <div class="">
                <div class="product-image" style="border: none !important">
                  <div class="ribbon ribbon-info" v-if="item.discount">
                    En oferta
                  </div>
                  <img
                    class="img-fluid productBorderRadius"
                    :src="item.image"
                    alt="product"
                  />
                  <div class="product-hover-overlay" style="border-radius: 4px">
                    <div
                      class="product-hover-overlay-buttons"
                      style="border-radius: 4px"
                    >
                      <a
                        class="btn btn-dark btn-buy"
                        style="background-color: #1c4c3b; border-radius: 4px"
                        href=""
                        ><span
                          class="btn-buy-label"
                          style="font-size: 11px; letter-spacing: 1px"
                          >Ver más</span
                        ></a
                      >
                    </div>
                  </div>
                </div>
                <div class="py-2">
                  <p class="mb-1 text-sm text-muted">{{ item.category }}</p>
                  <h3 class="mb-1 h6" style="text-transform: uppercase">
                    <a class="text-dark" href="detail.html">{{ item.name }}</a>
                  </h3>
                  <span v-if="USDEnabled == true" class="text-muted"
                    >AR{{ priceConverter(item.price) }}
                  </span>
                  <span v-if="USDEnabled == false" class="text-muted"
                    >AR{{ priceConverter(item.price * USDData.value) }}
                  </span>
                </div>
              </div>
            </router-link>
          </div>
          <!-- /product-->
        </div>
      </div>
    </section>
  </div>
</template>

<style>
.owl-theme.owl-dots-modern .owl-dots .owl-dot.active span {
  background-color: #1c4c3b !important;
}

.model1img {
  background: center center url("../assets/model1.jpg") no-repeat;
  background-size: cover;
}
.product-image {
  display: block;
  position: relative;
  overflow: hidden;
  height: 320px;
}
.sectionFix {
  margin-top: 95px;
}

.sectionTitle {
  width: 100%;
  padding-bottom: 8px;
  height: fit-content;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  gap: 5px;
  margin-top: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sectionTitle span {
  color: #1c4c3b;
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 0.1px;
  text-transform: uppercase;
}

.sectionTitle p {
  text-align: center;
  font-size: 18px;
  font-weight: 400;
}

.bannerTitle {
  padding-top: 170px;
  margin: 0 auto !important;
}

.btnSlider {
  background: rgba(0, 0, 0, 0.4);
  color: white;
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 600;
  backdrop-filter: blur(8px);
  text-transform: uppercase;
  border-radius: 8px;
}

.desktopCarousel {
  display: block;
}

.mobileCarousel {
  display: none;
}

@media (max-width: 700px) {
  .desktopCarousel {
    display: none;
  }

  .mobileCarousel {
    display: block;
  }
}

@media (max-width: 991px) {
  .sectionTitle p {
    font-size: 16px;
    font-weight: 400;
  }

  .desktopCarousel {
    display: none;
  }

  .mobileCarousel {
    display: block;
  }

  .btnSlider {
    background: rgba(0, 0, 0, 0.4);
    color: white;
    padding: 10px 20px;
    font-size: 11px;
    font-weight: 600;
    backdrop-filter: blur(8px);
    text-transform: uppercase;
    border-radius: 8px;
  }
  .sectionFix {
    margin-top: 93.38px;
  }
  .bannersCont {
    height: calc(100vh - 91.38px);
  }
  .sectionTitle {
    padding-bottom: 8px;
    height: fit-content;
    padding-bottom: 4px;
  }
  .sectionTitle span {
    font-size: 24px;
    font-weight: 600;
  }
  .bannerTitle {
    padding-top: 35px;
  }
}
</style>

<script>
// @ is an alias to /src
import axios from "axios";
import currencyFormatter from "currency-formatter";
import { initCarousel } from "../../public/assets/js/theme.d7b4a888";
import carousel from "vue-owl-carousel";

export default {
  name: "Home",
  components: {
    carousel,
  },
  data() {
    return {
      fourProducts: [],
      mostWantedProducts: [],
      freeShipping: "",
      slide: 0,
      sliding: null,
      USDData: {},
      USDEnabled: null,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    getFourProducts() {
      var loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: "#1c4c3b",
        opacity: 1,
      });
      axios
        .get(this.$url + "/public/getLatestProducts", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const { data } = response;
          this.fourProducts = data;
          loader.hide();
        })
        .catch((error) => {
          this.msm_error = error.response.data.msg;
          loader.hide();
        });
    },
    getMostWantedProducts() {
      axios
        .get(this.$url + "/public/getMostWantedProducts", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const { data } = response;
          this.mostWantedProducts = data;
        })
        .catch((error) => {
          console.log(error.response.data.msg);
          this.msm_error = error.response.data.msg;
        });
    },
    priceConverter(price) {
      return currencyFormatter.format(price, { code: "ARS" });
    },
    getUSDSettings() {
      axios
        .get(`${this.$url}/public/getusdsettings`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.USDData = response.data[0];
          console.log("usdsettings", response.data[0]);
          if (this.USDData.enabled === true) {
            this.USDEnabled = true;
          }
          if (this.USDData.enabled === false) {
            this.USDEnabled = false;
          }
        })
        .catch((error) => {
          console.log(error.response.data.msg);
        });
    },
  },
  beforeMount() {
    this.getFourProducts();
    this.getMostWantedProducts();
    this.getUSDSettings();
    initCarousel.init();
  },
};
</script>
